/* KENZ : script panier SIMPLIFIE.
   Il ne touche plus au contenu du panier (le theme gere tout seul le panier qui s'ouvre).
   Il garde seulement le pop-up « Avant de valider » (point relais) au clic sur Payer.
   Le pop-up est une vraie fenetre du navigateur (<dialog>) : il s'affiche donc TOUJOURS au-dessus
   de la fenetre panier, meme quand celle-ci est ouverte. */
(function(){
  'use strict';
  var RELAIS_HTML = ''
    + '<dialog class="kenz-relais" id="kenzRelais" aria-labelledby="kenzRelaisTitle">'
    +   '<div class="kenz-relais__back" data-kenz-relais-close></div>'
    +   '<div class="kenz-relais__box">'
    +     '<button type="button" class="kenz-relais__close" data-kenz-relais-close aria-label="Fermer">&times;</button>'
    +     '<div class="kenz-relais__ico"><svg viewBox="0 0 24 24"><path d="M12 2 3 7v10l9 5 9-5V7l-9-5Z"/><path d="M12 22V12M3 7l9 5 9-5"/></svg></div>'
    +     '<h3 id="kenzRelaisTitle">Avant de valider</h3>'
    +     '<p><b>Bon à savoir :</b> Économisez sur vos frais en optant pour une livraison en point relais (à sélectionner lors du paiement).</p>'
    +     '<p>En point relais, pensez à renseigner votre <b>numéro de téléphone</b> : il est obligatoire pour la commande.</p>'
    +     '<button type="button" class="kenz-relais__btn" id="kenzRelaisOk">J’ai compris</button>'
    +   '</div>'
    + '</dialog>';

  function ensureRelais(){
    var existing = document.getElementById('kenzRelais');
    if (existing) return existing;
    var wrap = document.createElement('div');
    wrap.innerHTML = RELAIS_HTML;
    var relais = wrap.firstChild;
    document.body.appendChild(relais);
    relais.addEventListener('click', function(e){
      e.stopPropagation();
      if (e.target.closest('[data-kenz-relais-close]')) closeRelais();
    });
    relais.querySelector('#kenzRelaisOk').addEventListener('click', function(){
      closeRelais();
      window.location.href = '/checkout';
    });
    /* touche Echap : on ferme seulement ce pop-up, pas le panier derriere */
    relais.addEventListener('cancel', function(e){ e.preventDefault(); e.stopPropagation(); closeRelais(); });
    relais.addEventListener('keydown', function(e){ if (e.key === 'Escape') e.stopPropagation(); });
    return relais;
  }
  function openRelais(){
    var r = ensureRelais();
    r.classList.add('is-open');
    try {
      if (!r.open) r.showModal();
    } catch (err) {
      r.setAttribute('open', '');
    }
  }
  function closeRelais(){
    var r = document.getElementById('kenzRelais');
    if (!r) return;
    r.classList.remove('is-open');
    try { if (r.open) r.close(); } catch (err) { r.removeAttribute('open'); }
  }

  /* au clic sur « Payer » : on affiche le pop-up au lieu de partir directement au paiement */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#checkout, button[name="checkout"]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    openRelais();
  }, true);

  /* menu : toucher le logo KENZ en haut a gauche du menu ramene a l'accueil
     (le logo est dessine en CSS, on regarde simplement si on a touche sa zone) */
  document.addEventListener('click', function(e){
    var drawer = e.target.closest && e.target.closest('.menu-drawer');
    if (!drawer) return;
    if (e.target.closest('a, button, summary, input, select, label')) return;
    var r = drawer.getBoundingClientRect();
    var x = e.clientX - r.left, y = e.clientY - r.top;
    var left = Math.min(Math.max(r.width * 0.06, 28), 56);
    if (x >= left - 12 && x <= left + 170 && y >= 8 && y <= 66) {
      window.location.href = '/';
    }
  });
})();
